import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/assets/css/roboto.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import './plugins/vuetify'
import App from './App.vue'
import colors from 'vuetify/es5/util/colors'
import { store } from './store'
import Routes from './js/routes'
import axios from 'axios'
import { api_interceptor_req_cfg, api_interceptor_req_err } from './js/api'
import { api_interceptor_resp_cfg, api_interceptor_resp_err } from './js/api'
import socketio from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'


Vue.config.productionTip = false

Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  theme: {
    primary: colors.purple,
    secondary: colors.amber
  },
  iconfont: 'md'
})

Vue.use(VueRouter)

const router = new VueRouter({
  routes: Routes,
  mode: 'history'
})

// let api_url = 'http://localhost:5000/'
// let api_url = 'https://api.ecovoip.co.za:12494/'
let api_url = process.env.VUE_APP_APIURL

var api = axios.create({
  baseURL: api_url,
  timeout: 30000
})

api.interceptors.request.use(api_interceptor_req_cfg, api_interceptor_req_err)
api.interceptors.response.use(api_interceptor_resp_cfg, api_interceptor_resp_err)
Vue.prototype.$api = api

const SocketInstance = socketio(api_url)
Vue.use(new VueSocketIO({
  debug: false,
  //connection: 'http://localhost:5000',
  connection: SocketInstance,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))

new Vue({
  store,
  render: h => h(App),
  router: router
}).$mount('#app')
